module.exports = __webpack_public_path__ + "images/emoji/two.812926fca51a19d76aba.png";